import './Home.css';
import React from "react";
import './Blog.css'


class GrafanaPlugins extends React.Component {

    componentDidMount(){
        document.title = "Grafana Plugings"
    }

    render() {
        return (
            <>
            <section className="blog-title">
                <h3>{this.props.title}</h3>
                <div className="blog-date">{this.props.postDate}</div>
            </section>
            <section>
                <div className="blog-date">
                    {this.props.date}
                </div>
            </section>
            <section className="content">
                <section className="post">
                    <p>
                        Grafana is one of the best metrics visualization tools so far that I have come across. Plug and play are what I like more about it.
                        <br/>
                        Migrations are always hard. Grafana migration from 7.5.* to 8.* is not a big surprise as well.
                        The team though it will be just version update and plugins setup. But wait surprises are always there.
                        
                        Based on the doc, we just set the special variable <code>GF_INSTALL_PLUGINS</code> that's it.
                        And then we were getting
                        <pre>
                            <code>
                            Error: ✗ failed to download plugin archive: &#60;?xml version='1.0' encoding='UTF-8'?&#62;&#60;Error&#62;&#60;Code&#62;SecurityPolicyViolated&#60;/Code&#62;&#60;Message&#62;Request violates VPC Service Controls.&#60;/Message&#62;&#60;Details&#62;Request is prohibited by organization's policy. vpcServiceControlsUniqueIdentifier: xXLILqaJM0zPkKkvM8J23tg9Q8BZBEcsy6wEddm9Lwvf3SdPoYpCfQ&#60;/Details&#62;&#60;/Error&#62; (Grafana v8.3.3 linux-amd64)
                            </code>
                        </pre>

                        Seems like they have moved the plugins to GCP bucket with restricted policies 
                        So I come up with a manual installation approach in Dockerfile as below:

                        <pre>
                            <code>
                            # Dockerfile {"\n"}
                            FROM grafana/grafana:8.3.3{"\n"}
                            RUN grafana-cli plugins install fetzerch-sunandmoon-datasource {"\n"}
                            RUN grafana-cli plugins install grafana-piechart-panel {"\n"}
                            RUN grafana-cli plugins install mtanda-heatmap-epoch-panel {"\n"}
                            RUN grafana-cli plugins install briangann-datatable-panel {"\n"}
                            RUN grafana-cli plugins install briangann-gauge-panel {"\n"}
                            RUN grafana-cli plugins install fzakaria-simple-annotations-datasource {"\n"}
                            RUN grafana-cli plugins install grafana-simple-json-datasource {"\n"}
                            RUN grafana-cli plugins install mtanda-histogram-panel {"\n"}
                            RUN grafana-cli plugins install michaeldmoore-annunciator-panel {"\n"}
                            RUN grafana-cli plugins install flant-statusmap-panel {"\n"}
                            RUN grafana-cli plugins install simpod-json-datasource {"\n"}
                            RUN grafana-cli plugins install grafana-kubernetes-app {"\n"}
                            </code>
                        </pre>

                        <br/>
                        Everything went smoother but still, plugins were not shown.
                        No wonder there were missing plugins in the default grafana plugin directory
                        <pre>
                            <code>
                            ✗ kubect  exec -it grafana-cbdb58d99-ktpxf sh {"\n"}
                            /usr/share/grafana # ls -al /var/lib/grafana/plugins {"\n"}
                            /usr/share/grafana #
                            </code>
                        </pre>

                        Looked at the deployment and it was volume mount which was overriding the <code>/var/lib/plugin</code> 
                        So now plugin directory must be moved to custom one and set to <code>/var/lib/grafana-plugins</code>
                        
                        <pre>
                            <code>
                            # Dockerfile {"\n"}
                            FROM grafana/grafana:8.3.3{"\n"}
                            RUN mkdir -p /var/lib/grafana-plugins{"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install fetzerch-sunandmoon-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install grafana-piechart-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install mtanda-heatmap-epoch-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install briangann-datatable-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install briangann-gauge-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install fzakaria-simple-annotations-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install grafana-simple-json-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install mtanda-histogram-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install michaeldmoore-annunciator-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install flant-statusmap-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install simpod-json-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install grafana-kubernetes-app {"\n"}
                            </code>
                        </pre>
                        <br/>

                        But still, the plugin wasn't shown in Grafana UI. It was a permission issue on the plugin directory.
                        Also, make sure you have <code>allow_loading_unsigned_plugins</code> variable updated in <code>/etc/grafana/grafana.ini</code>
                        Below configuration in Dockerfile finally worked.
                        <pre>
                            <code>
                            # Dockerfile {"\n"}
                            FROM grafana/grafana:8.3.3 {"\n"}

                            USER root{"\n"}
                            RUN mkdir -p /var/lib/grafana-plugins{"\n"}
                            RUN chown 472:0 /var/lib/grafana-plugins{"\n"}

                            USER grafana
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install fetzerch-sunandmoon-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install grafana-piechart-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install mtanda-heatmap-epoch-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install briangann-datatable-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install briangann-gauge-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install fzakaria-simple-annotations-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install grafana-simple-json-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install mtanda-histogram-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install michaeldmoore-annunciator-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install flant-statusmap-panel {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install simpod-json-datasource {"\n"}
                            RUN grafana-cli --pluginsDir=/var/lib/grafana-plugins plugins install grafana-kubernetes-app {"\n"}
                            </code>
                        </pre>
                        
                        <br/>

                        Just want to mention here, whenever you are stuck with some solution try to find out alternatives. Don't waste more time thinking of the same solution.
                        It will widespread your views.
                        <br/>
                        Feel free to tag on <a href="https://twitter.com/p__nitin" _target="_blank" rel="noreferrer">twitter </a>if you have queries or comments.
                    </p>

                </section>
            </section>
            </>
        )
    }
}

export default GrafanaPlugins;
